<template>
  <div class="box enable-scroll">
    <ion-icon class="icon" name="close-circle" @click="hideModal"></ion-icon>
    <div class="title">{{ title }}</div>
    <div class="content" :class="text_align" v-for="item in content" v-bind:key="item.index">{{ item }}</div>
    <div class="button-box">
      <ion-button v-if="show_confirm" class="button" @click="ok">{{confirm_text}}</ion-button>
    </div>
  </div>
</template>

<script>
import {IonButton, IonIcon, modalController } from "@ionic/vue";
import common from '@/common'

export default {
  name: "AlertModalTemplate",
  components: {
    IonButton,
    IonIcon
  },
  props: {
    show_confirm: {type: String, default: ''},
    confirm_text: {type: String, default: '確定'},
    confirm_fun: {type: Function, default: function (){return}},
    text_align: {type: String, default: ''},
  },
  data() {
    return {
      title: common.config.alertModal.title,
      content: common.config.alertModal.content,
    }
  },
  methods: {
    hideModal: function () {
      modalController.dismiss();
    },
    ok: function () {
      this.confirm_fun()
      // modalController.dismiss();
    }
  }
}
</script>

<style scoped>
  .box{
    padding: 0 clamp(1.5rem, 4vw, 3rem);
    overflow-y: auto;
  }
  .icon{
    position: absolute;
    right: 4px;
    top: 4px;
    font-size: var(--ecs-icon-lg);
    color: #b3b3b3;
  }
  .title{
    text-align: center;
    font-size: var(--ecs-font-md);
    color: #61005f;
    padding: clamp(.5rem, 2vw, 1rem);
    border-bottom: 1px solid grey;
    margin-bottom: clamp(.5rem, 2vw, 1rem);
  }
  .content{
    /* margin: clamp(.5rem, 1vw, 1rem) auto; */
    font-size: var(--ecs-font-md);
    line-height: 1.35;
  }
  .button-box{
    /*margin: auto 1vh;*/
    margin-top: clamp(1rem, 2vw, 2rem);
    text-align: center;
  }
  .button{
    --background: #94c43b;
    --padding-top: clamp(0.5rem, 1.4vw, 0.875rem);
    --padding-bottom: clamp(0.5rem, 1.4vw, 0.875rem);
    width: min(16rem, 80%);
    min-height: var(--ecs-option-min-height);
    height: auto;
    white-space: normal;
    font-size: var(--ecs-font-md);
  }
  .text-center{
    text-align: center;
  }
</style>
